module.exports = __webpack_public_path__ + "img/guigeliao1.85757a7a.jpg";